<template>
  <ul id="habilidades-lista">
    <li
      class="item-lista"
      v-for="({ href, title, src, alt }, index) in skill"
      :key="index"
    >
      <a :href="href" target="_blank" rel="noopener noreferrer">
        <Tilt :options="tiltOption">
          <img :title="title" :src="src" :alt="alt" />
        </Tilt>
      </a>
    </li>
  </ul>
</template>

<script>
import Tilt from "vanilla-tilt-vue";

export default {
  name: "SkillVue",
  props: {
    skill: { type: Object, required: true },
  },
  setup() {
    const tiltOption = {
      perspective: 400,
      scale: 1.5,
    };
    return { tiltOption };
  },
  components: {
    Tilt,
  },
};
</script>

<style scoped>
#habilidades-lista {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(70px, 130px));
  justify-content: center;
  gap: 30px;
}

#habilidades-lista .item-lista img {
  width: 108px;
  height: 108px;
}
</style>
